import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { kinetik_api_url } from "~/app/utilities/const";
import axios from "axios";
//import { responseURL, AccountKey, UserID } from '~/app/utilities/const';
import { StatusCard } from "~/app/index";
import {addViewBatches} from '../status_card_view/actions'
import FontAwesome from 'react-fontawesome';
import _ from "underscore";

class StatusCardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dos_filter_order: "asc",
      payer_filter_order: "asc",
      filename_filter_order: "asc",
      lastupdated_filter_order: "asc",
    };
  }
  componentWillMount = () => {
    const bill_npi= localStorage.getItem('bill_npi');
    const token = localStorage.getItem('authToken');
    axios
      .get(kinetik_api_url + "/batch/recent/"+bill_npi+"?token="+token)
      .then(response => {
        this.props.addViewBatches(response.data);
      })
      .catch(err => {
        console.log("/batch error:", err);
      });
  };
  renderStatusCards = batches => {
    
    return _.map(batches, (batch, index) => {
      if(this.props.status_card_index===index || this.props.status_card_index===-1){
        return <StatusCard key={index} index={index} batch={batch} />;
      }
    });
  };
  handleFilterClick = (filterType) =>{
    const currentViewBatches = Object.assign({},this.props.view_batches);
    let newFilterOrder;
    let newViewBatches=[];
    switch (filterType) {
      case "dos":
        newViewBatches=_.sortBy(currentViewBatches,batch=>{
          return batch.date_submitted;
        })
        newFilterOrder = (this.state.dos_filter_order==="asc")?"dsc":"asc"; // toggle filter order
        this.setState({dos_filter_order:newFilterOrder});
        if(newFilterOrder==="dsc") newViewBatches.reverse();
        break;
        case "payer":
        newViewBatches=_.sortBy(currentViewBatches,batch=>{
          return batch.payerid;
        })
        newFilterOrder = (this.state.payer_filter_order==="asc")?"dsc":"asc"; // toggle filter order
        this.setState({payer_filter_order:newFilterOrder});
        if(newFilterOrder==="dsc") newViewBatches.reverse();
        break;
        case "filename":
        newViewBatches=_.sortBy(currentViewBatches,batch=>{
          return batch.file_name;
        })
        newFilterOrder = (this.state.filename_filter_order==="asc")?"dsc":"asc"; // toggle filter order
        this.setState({filename_filter_order:newFilterOrder});
        if(newFilterOrder==="dsc") newViewBatches.reverse();
        break;
        case "lastupdated":
        newViewBatches=_.sortBy(currentViewBatches,batch=>{
          return batch.last_updated;
        })
        newFilterOrder = (this.state.lastupdated_filter_order==="asc")?"dsc":"asc"; // toggle filter order
        this.setState({lastupdated_filter_order:newFilterOrder});
        if(newFilterOrder==="dsc") newViewBatches.reverse();
        break;
      default:
        break;
    }

    this.props.addViewBatches(newViewBatches);
  }

  render = () => {
    return (
      <div>       
        <div className="container">
          <div className="row text-center">
            <div className="col-sm-2">
            <button className="no-border" onClick={()=>this.handleFilterClick("dos")}>Date of Submission <FontAwesome name={(this.state.dos_filter_order==="asc")?"caret-up":"caret-down"}/></button>
            </div>
            <div className="col-sm-2">
            <button className="no-border" onClick={()=>this.handleFilterClick("payer")}>Payer <FontAwesome name={(this.state.payer_filter_order==="asc")?"caret-up":"caret-down"}/></button>
            </div>
            <div className="col-sm-3">
            <button className="no-border" onClick={()=>this.handleFilterClick("filename")}>File Name <FontAwesome name={(this.state.filename_filter_order==="asc")?"caret-up":"caret-down"}/></button>
            </div>
            <div className="col-sm-2">
            <button className="no-border">Status</button>
            </div>
            <div className="col-sm-3">
            <button className="no-border" onClick={()=>this.handleFilterClick("lastupdated")}>Last Updated <FontAwesome name={(this.state.lastupdated_filter_order==="asc")?"caret-up":"caret-down"}/></button>
            </div>
          </div>
        </div>

        {this.props.view_batches !== null &&
          this.renderStatusCards(this.props.view_batches)}
      </div>
    );
  };
}

const mapStateToProps = state => {
  return {
    view_batches: state.statusUpdates.view_batches,
    provider_info: state.userData.provider_info,
    status_card_index: state.statusUpdates.status_card_index
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewBatches:addViewBatches
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(StatusCardView);





// WEBPACK FOOTER //
// ./src/app/batch_status/status_card_view/Status_Card_View.js